<template>
    <div class="container-fluid">
      <div class="row mb-1">
          <div class="col-sm text-start pb-1">
              <span class="badge rounded-pill pull-left mt-1 py-2 px-4 me-5" style="font-size:18px; background:gray">
                  <b>Lab Status Report : รายงานสถานะใบสั่งตรวจ</b>
              </span>
              <div class="badge rounded-pill border pull-left mt-1 pt-0 pb-0 px-4 me-5 text-dark" style="font-size:14px;background:AntiqueWhite">
                  <div class="form-check form-check-inline mx-3" title="แสดงรายการสถานะใหม่">
                  <input class="form-check-input" type="checkbox" id="inlineCheckbox1" v-model="status0New">
                  <label class="form-check-label mt-1" for="inlineCheckbox1"><b>New</b> </label>
                  </div>
                  <div class="form-check form-check-inline mx-2 " title="แสดงรายการที่รับเข้าห้องแล็บแล้ว">
                  <input class="form-check-input" type="checkbox" id="inlineCheckbox2" v-model="status1Lab">
                  <label class="form-check-label mt-1" for="inlineCheckbox2"><b>Lab</b> </label>
                  </div>
                  <div class="form-check form-check-inline mx-3 pt-2" title="แสดงรายการที่ป้อนผลแล้วรออนุมัติ">
                  <input class="form-check-input" type="checkbox" id="inlineCheckbox3" v-model="status2Res">
                  <label class="form-check-label mt-1" for="inlineCheckbox3"><b>Resulted</b> </label>
                  </div>
                  <div class="form-check form-check-inline mx-2 " title="แสดงรายการที่ป้อนผลและอนุมัติแล้ว">
                  <input class="form-check-input" type="checkbox" id="inlineCheckbox4" v-model="status3App">
                  <label class="form-check-label mt-1" for="inlineCheckbox4"><b>AP</b> </label>
                  </div>
              </div>
          </div>
      </div>
      <div class="row">
          <div class="col-sm">
              <div class="row">
                  <div class="col-sm-4">
                    <!-- สาขาแล็บ -->
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" style="width:120px;">สาขา* :</span>
                        <select class="form-select form-select-sm" ref="BranchID" id="BranchID" name="BranchID" v-model="branchID" >
                            <option disabled value="">Please select one</option>
                            <option v-for="item in dataBranchlists" :key="item.BranchID" :value="item.BranchID">{{ item.BranchName }}</option>
                        </select>
                    </div>
                  </div>
                  <div class="col-sm">
                    <!-- วันที่ใบสั่งตรวจ -->
                    <div class="input-group input-group-sm mb-1">
                      <span class="input-group-text" style="width:160px;">วันที่เอกสาร จาก-ถึง :</span>
                      <v-date-picker mode="date" v-model="dateFm" :masks="masks">
                          <template v-slot="{ inputValue, inputEvents }">
                              <input name="dateFm" ref="dateFm" style="width:120px;"
                              class="bg-white border px-2 py-1 rounded"
                              :value="inputValue"
                              v-on="inputEvents"
                              />
                          </template>
                      </v-date-picker>
                      <v-date-picker mode="date" v-model="dateTo" :masks="masks">
                          <template v-slot="{ inputValue, inputEvents }">
                              <input name="dateTo" ref="dateTo" style="width:120px;"
                              class="bg-white border px-2 py-1 rounded"
                              :value="inputValue"
                              v-on="inputEvents"
                              />
                          </template>
                      </v-date-picker>
                      <button type="button" class="btn btn-info btn-sm text-white mx-2" @click="getData()">ดึงข้อมูล</button>
                    </div>
                  </div>
              </div>
          </div>
      </div>
      <RepLabStatus1View :datalists="datalists" :key="countRefresh"></RepLabStatus1View>
      <!-- <div class="row ">
        <div class="col-sm">
            <table id="myRepLabStatusTable" class="table table-striped table-hover table-bordered table-sm" style="width: 100%;">
                <thead class="text-dark" style="background:NavajoWhite">
                <tr>
                    <th>รหัส</th>
                    <th class="text-start">ชื่อเทส</th>
                    <th class="text-start">ค่าปกติ</th>
                    <th>หน่วย</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datalists" :key="item.ROID">
                    <td class="text-start">{{ item.RONo }}</td>
                    <td class="text-start">{{ item.DocDate }}</td>
                    <td class="text-start">{{ item.PatName }} {{ item.PatLName}}</td>
                    <td class="text-start">{{ arrSex[item.Sex] }}</td>
                </tr>
                </tbody>
            </table>
        </div>
      </div> -->
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import RepLabStatus1View from './RepLabStatus1View.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  masks: {
    input: 'YYYY-MM-DD'
  },
  name: 'RepLabStatus',
  components: {
    RepLabStatus1View
  },
  data () {
    return {
      arrRepeatChk: ['', 'R'],
      arrSex: ['', 'ชาย', 'หญิง'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      // เงื่อนไขสำหรับดึงข้อมูลหน้าหลัก
      branchID: 0,
      dateFm: new Date(),
      dateTo: new Date(),
      status0New: true,
      status1Lab: true,
      status2Res: true,
      status3App: true,

      countRefresh: 0,
      activePageCRU: 0, // 0-View List/ 1-Create/ 2-Update/3-View Doc
      datalists: null,
      // รายชื่อสาขาทั้งหมด สำหรับเลือกใน Header Table
      dataBranchlists: null
    }
  },
  created () {
    // Initial Value
    this.getBranchData()
  },
  mounted () {
    this.branchID = this.globalBranchID
  },
  methods: {
    viewRecord (row) {
      this.curRecord = row
      // this.action = 'view'
      this.activePageCRU = 3 // 0-List Table 1-New 2-Edit 3-View Doc
    },
    getBranchData () {
      MyApiClient.get('getdata/branch_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.dataBranchlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getData () {
      var docDateFm = this.dateFm.toISOString().slice(0, 10)
      var docDateTo = this.dateTo.toISOString().slice(0, 10)
      var BranchID = this.branchID
      var Status0 = -1 // 0-New
      var Status1 = -1 // 1-Lab
      var Status2 = -1 // 2-Resulted
      var Status3 = -1 // 3-Approve
      if (this.status0New) {
        Status0 = 0 // 0-New
      }
      if (this.status1Lab) {
        Status1 = 1 // 1-Lab
      }
      if (this.status2Res) {
        Status2 = 2 // 2-Resulted
      }
      if (this.status3App) {
        Status3 = 3 // 3-Approve
      }
      // console.log('getdata/replabstatus_where.php?BranchID=' + BranchID + '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo +
      //   '&Status0=' + Status0 + '&Status1=' + Status1 + '&Status2=' + Status2 + '&Status3=' + Status3)
      MyApiClient.get('getdata/replabstatus_where.php?C1=' + this.globalCorpID + '&BranchID=' + BranchID + '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo +
        '&Status0=' + Status0 + '&Status1=' + Status1 + '&Status2=' + Status2 + '&Status3=' + Status3)
      // MyApiClient.get('getdata/tests_all.php')
        .then((resp) => {
        //   console.log(resp.data.response)
          this.datalists = resp.data.response
          if (this.datalists == null) {
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
          }
          this.$nextTick(() => {
            $('#myRepLabStatusTable').DataTable()
          })
          // setTimeout(function () { $('#myRepLabStatusTable').DataTable() }, 0)
          this.countRefresh++
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
